var ACTIVE_PARAMETER_SELECTOR =
  ".parameter-dependent:not(.no-display):not(.noDisplay):not(.default-variant)";
var SPLIT_SELECTOR =
  ".variant-list .hidden-split-parameter, .variant-list .split-parameter";

function getVariantDataMap() {
  return window.shoptet &&
    shoptet.variantsSplit &&
    shoptet.variantsSplit.necessaryVariantData
    ? shoptet.variantsSplit.necessaryVariantData
    : null;
}

function variantHasSale(variantKey) {
  var variantData = getVariantDataMap() && getVariantDataMap()[variantKey];
  if (!variantData) return false;

  var standardPrice = parseInt(
    String(variantData.standardPrice || "").replace(/\D/g, ""),
    10,
  );
  var finalPrice = parseInt(
    String(variantData.price || "").replace(/\D/g, ""),
    10,
  );
  return (
    !isNaN(standardPrice) && !isNaN(finalPrice) && standardPrice > finalPrice
  );
}

function isVariantDisabled($variant) {
  return $variant.hasClass("disabled");
}

function buildCustomVariants() {
  if (
    $("#simple-variants").length ||
    !$(".variant-list, .surcharge-list").length
  )
    return;

  $("body").addClass("hasVariants");

  $(".variant-list select, .surcharge-list select").each(function () {
    var $select = $(this);
    var parameterId = $select.data("parameter-id");
    var tooltip =
      $select
        .closest(".surcharge-list")
        .find("th .show-tooltip")
        .attr("title") || "";
    var isVariantList =
      $select.closest("td").find('select[name*="parameterValueId"]').length > 0;
    var html =
      '<div class="custom-variant" data-groupId="' +
      parameterId +
      '"><div class="tms">Rozměr:</div><div class="custom-variant-wrap" data-param-id="' +
      parameterId +
      '">';

    $select.find("option").each(function () {
      var $option = $(this);
      if (!$.isNumeric($option.val())) return;

      var value = $option.attr("value");
      var label = $option.text();

      if (isVariantList) {
        var parts = label.split("+");
        html +=
          '<div class="variant haveVariant" data-value="' +
          value +
          '" data-parameter-id="' +
          parameterId +
          '" data-param-val="' +
          parameterId +
          "-" +
          value +
          '"><div class="text"><span class="label">' +
          $.trim(parts[0]) +
          "</span>";
        if (tooltip && parts[1] !== "0 Kč") {
          html +=
            '<span class="show-tooltip question-tooltip" title="' +
            tooltip +
            '">?</span>';
        }
        html += "</div></div>";
        return;
      }

      html +=
        '<div class="variant haveSurcharge show-tooltip" title="' +
        label +
        '" data-value="' +
        value +
        '" data-parameter-id="' +
        parameterId +
        '" data-param-val="' +
        parameterId +
        "-" +
        value +
        '"><div class="image"><img src="/user/documents/upload/obrazky/detail/priplatky/' +
        value +
        ".svg?v=" +
        new Date().getMinutes() +
        '" alt="' +
        label +
        '"></div></div>';
    });

    html += "</div></div>";
    $select.after(html).hide();
    $select.closest(".variant-list span, .surcharge-list span").hide();
  });
}

function attachVariantMetadata() {
  var map = getVariantDataMap();
  if (!map) return;

  Object.keys(map).forEach(function (key) {
    var variant = map[key];
    var availability = variant.availabilityName
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ /g, "-");
    $('.custom-variant-wrap .variant[data-param-val="' + key + '"]')
      .addClass("haveImage")
      .attr("data-price-id", variant.id)
      .attr("data-avail", availability)
      .toggleClass("disabled", availability === "Momentalne-nedostupne")
      .attr("data-sale", variantHasSale(key));
  });
}

function updateUnavailableVariants() {
  $(".custom-variant-wrap .variant").each(function () {
    var $variant = $(this);
    var parameterId = $variant.data("parameter-id");
    var value = $variant.data("value");
    var unavailable = $(
      "select[data-parameter-id='" +
        parameterId +
        "'] option[value='" +
        value +
        "']",
    ).hasClass("unavailable-option");

    $variant.toggleClass("unavailable", unavailable);
    if (unavailable) $variant.removeClass("active");
  });
}

function updateCustomCartSaleState() {
  var hasSale =
    $(".custom-variant-wrap .variant.active").filter(function () {
      return $(this).attr("data-sale") === "true";
    }).length > 0;
  $(".customCart").toggleClass("sale", hasSale);
}

function updateAvailabilityDeliveryNote() {
  var $availability = $(".availability-value");
  if (!$availability.length) return;

  $availability.find(".delivery-time-note").remove();

  var deliveryText = $.trim(
    $(".delivery-time").find(ACTIVE_PARAMETER_SELECTOR).first().text(),
  );
  if (!deliveryText || deliveryText === "-") return;

  var style =
    $availability
      .find(ACTIVE_PARAMETER_SELECTOR)
      .first()
      .find(".availability-label")
      .attr("style") || "";
  $(
    '<span class="delivery-time-note"><span>, můžete mít </span>' +
      deliveryText.replace(/\.\d{4}$/, "") +
      "</span>",
  )
    .attr("style", style)
    .appendTo($availability);
}

function updateCurrentVariantLabel() {
  $(".custom-variant").each(function () {
    var $customVariant = $(this);
    var $title = $customVariant.find(".tms").first();
    if (!$title.length) return;

    var base =
      $title.attr("data-base-label") ||
      $.trim($title.clone().children(".current").remove().end().text()) ||
      "Rozměr:";
    var current = $.trim(
      $customVariant.find(".variant.active .label").first().text(),
    );

    $title.attr("data-base-label", base).html(base);
    if (current) $title.append('<span class="current">' + current + "</span>");
  });
}

function refreshVariantUi() {
  updateUnavailableVariants();
  updateCustomCartSaleState();
  updateAvailabilityDeliveryNote();
  updateCurrentVariantLabel();
}

function setInitialActiveVariant() {
  $(".custom-variant-wrap").each(function () {
    var $variants = $(this).find(".variant");
    if ($variants.length === 1 && !isVariantDisabled($variants.first()))
      $variants.addClass("active");
  });

  var valueFromUrl = new URLSearchParams(window.location.search).get(
    "parameterValueId",
  );
  if (valueFromUrl) {
    $("div.variant[data-value='" + valueFromUrl + "']")
      .not(".disabled")
      .addClass("active");
  }
}

buildCustomVariants();
attachVariantMetadata();

$(document).on("click", ".custom-variant-wrap .variant", function () {
  var $variant = $(this);
  if (isVariantDisabled($variant)) return;

  var parameterId = $variant.data("parameter-id");
  var value = $variant.data("value");
  var $select = $("select[data-parameter-id='" + parameterId + "']");

  $select
    .find("option[value='" + value + "']")
    .prop("selected", true)
    .change();
  $variant
    .closest('.custom-variant-wrap[data-param-id="' + parameterId + '"]')
    .find(".variant")
    .removeClass("active");
  $variant.addClass("active");

  $(SPLIT_SELECTOR).trigger("change");
  if ($select[0]) $select[0].dispatchEvent(new Event("change"));

  refreshVariantUi();
});

$(document).on("click", "#jsUnavailableCombinationMessage a", function () {
  $(".custom-variant-wrap .variant").removeClass("unavailable");
});

$(document).ready(function () {
  setInitialActiveVariant();
  refreshVariantUi();
});
